<template>
    <mslPage :aIndex="0">
        <template v-slot:mslBody>
            <div class="index">
                <!-- banner轮播图 -->
                <div class="swiper">
                    <swiper ref="mySwiper" :options="swiperOptions">
                        <swiper-slide v-for="item in bannerPic" :key="item.id">
                            <transition name="fade">
                                <div class="banner r_position pointer row_center" :style="'background-image:url(' + item.pic_path + ')'" v-if="showBannerTxt">
                                    <div class="center banner_center a_position">
                                        <div class="content a_position flex flex-dir-top flex-main-center">
                                            <div class="mt">
                                                <div class="title">{{ item.title }}</div> <!-- 德国品质 服务中国 -->
                                                <div class="intro">{{ item.extend }}</div> <!-- 专门生产精密净水设备，核心净水技术更放心 -->
<!--                                                <router-link to="./production_detail" class="td_none">-->
<!--                                                    <div class="more pointer row_center leave_slowly hover_slowly">-->
<!--                                                        <span>查看详情</span>-->
<!--                                                    </div>-->
<!--                                                </router-link>-->
                                            </div>
                                        </div>
                                    </div>
<!--                                    <img :src="item.pic_path" alt=""> &lt;!&ndash; ../assets/pc_pic/index/banner_1.png &ndash;&gt;-->
                                </div>
                            </transition>
                        </swiper-slide>
<!--                        <swiper-slide>-->
<!--                            <div class="banner row_center">-->
<!--                                <img src="../assets/pc_pic/index/banner_1.png" alt="">-->
<!--                            </div>-->
<!--                        </swiper-slide>-->
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </div>
                <!-- 推荐产品轮播图 -->
                <hotProduction></hotProduction>
                <!-- 企业背景 -->
                <div class="enterprise">
                    <div class="e_img"></div>
                    <div class="e_bg">
                        <div class="center m_center enterprise_center column_center">
                            <div class="title ta_center" v-if="baseInfo.index_backdrop && baseInfo.index_backdrop.id">{{ baseInfo.index_backdrop.title }}</div>
                            <div class="intro ta_center" v-if="baseInfo.index_backdrop && baseInfo.index_backdrop.id" v-html="baseInfo.index_backdrop.content"></div>
                        </div>
                    </div>
                </div>
                <!-- 最新资讯 -->
                <div class="news">
                    <div class="center m_center news_center">
                        <div class="header column_center">
                            <div class="title">最新资讯</div>
                            <div class="line"></div>
                        </div>
                        <div class="news_area left_center">
                            <router-link :to="{ name: 'news_detail', query: { id: newsList[0].id } }" v-if="newsList[1] && newsList[1].id">
                                <div class="left pointer r_position" style="white-space: normal;">
                                    <img :src="[ newsList[0].image_path ? newsList[0].image_path : img ]" alt="" class="pointer image">
                                    <div class="r_txt a_position hover_slowly leave_slowly flex flex-cross-bottom" style="white-space: normal;">
                                        <div class="w" style="white-space: normal;">
                                            <div class="r_title w d_ellipsis">{{ newsList[0].title }}</div>
                                            <div class="r_intro w m_ellipsis">{{ newsList[0].content }}</div>
                                            <div class="n_more">
                                                <span>查看详情</span>
                                                <span class="iconfont iconarrow_right-23 more-icon"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                            <div class="right" v-if="newsList[1] && newsList[1].id">
                                <router-link :to="{ name: 'news_detail', query: { id: newsList[1].id } }">
                                    <div class="r_card pointer r_position">
                                        <img :src="[ newsList[1].image_path ? newsList[1].image_path : img ]" alt="" class="image">
                                        <div class="r_txt a_position hover_slowly leave_slowly flex flex-cross-bottom">
                                            <div class="w">
                                                <div class="r_title w d_ellipsis">{{ newsList[1].title }}</div>
                                                <div class="r_intro w m_ellipsis"> {{ newsList[1].content }}</div>
                                                <div class="n_more">
                                                    <span>查看详情</span>
                                                    <span class="iconfont iconarrow_right-23 more-icon"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                                <router-link :to="{ name: 'news_detail', query: { id: newsList[2].id } }" v-if="newsList[2] && newsList[2].id">
                                    <div class="r_card pointer r_position mt_48">
                                        <img :src="[ newsList[2].image_path ? newsList[2].image_path : img ]" alt="" class="image">
                                        <div class="r_txt a_position hover_slowly leave_slowly flex flex-cross-bottom">
                                            <div class="w">
                                                <div class="r_title w d_ellipsis">{{ newsList[2].title }}</div>
                                                <div class="r_intro w m_ellipsis" v-html="">{{ newsList[2].content }}</div>
                                                <div class="n_more">
                                                    <span>查看详情</span>
                                                    <span class="iconfont iconarrow_right-23 more-icon"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div class="more_area row_center">
                            <router-link to="./news" class="td_none">
                                <div class="more row_center hover_slowly leave_slowly">更多资讯</div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="center card_center m_center row_center">
                        <div class="item column_center leave_slowly hover_slowly pointer">
                            <div class="title">企业愿景</div>
                            <div class="intro_center">
                                <div class="intro ta_center">成就智能健康行业</div>
                                <div class="intro ta_center">高端优质品牌</div>
                            </div>
                        </div>
                        <div class="item column_center leave_slowly hover_slowly pointer">
                            <div class="title">企业发展</div>
                            <div class="intro_center">
                                <div class="intro ta_center">引领技术潮流</div>
                                <div class="intro ta_center">不断创新发展</div>
                            </div>
                        </div>
                        <div class="item column_center leave_slowly hover_slowly pointer">
                            <div class="title">企业使命</div>
                            <div class="intro_center">
                                <div class="intro ta_center">让更多的人使用上</div>
                                <div class="intro ta_center">智能健康的曼稣勒品牌产品</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </mslPage>
</template>

<script>
    import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay, Navigation ,EffectFade,EffectCoverflow} from 'swiper/core'
    SwiperClass.use([Pagination, Mousewheel, Autoplay,Navigation,EffectFade,EffectCoverflow])
    import hotProduction from '../components/hot_production'
    import { indexBanner, baseInfo, newsList } from '../api/common.js'
    export default {
        name: "index",
        components: {
            hotProduction
        },
        data() {
            return {
                formData: {
                    page: 1,
                    limit: 3,
                    diyname: 'news'
                },
                newsList: [],
                bannerPic: [],
                baseInfo: {},
                showBannerTxt: false,
                swiperOptions: {
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    direction: 'vertical',
                    loop: true,
                    autoplay: {
                        delay: 3000, // 自动切换的时间间隔（单位ms）
                        disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay
                    },
                    effect: 'fade',
                    fadeEffect: true,
                    speed: 1000
                }
            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            }
        },
        mounted() {
            this.showBannerTxt = true;
            this.swiperBanner();
            this.getBaseInfo();
            this.getNewsList();
            // console.log('Current Swiper instance object', this.swiper)
            // this.swiper();
        },
        methods: {
            async getNewsList () {
                console.log('资讯');
                let list = this.newsList;
                let data = {
                    ...this.formData
                }
                let res = await newsList(data);
                if (res.code == 1) {
                    list = res.data.list;
                    this.newsList = list;
                    this.newsList.forEach((item, index) => {
                        if (!!item.content) {
                            let content = item.content;
                            content = content.replace(/(\n)/g, "");
                            content = content.replace(/(\t)/g, "");
                            content = content.replace(/(\r)/g, "");
                            content = content.replace(/<\/?[^>]*>/g, "");
                            content = content.replace(/\s*/g, "");
                            item.content = content;
                            console.log(item.content, 'item.content');
                        }
                    })
                }
                // try {
                //
                // } catch {
                //     this.$message.error('加载资讯数据失败');
                // }
            },
            getBaseInfo () {
                try {
                    baseInfo().then(res => {
                        console.log(res, 'res');
                        if(res.code == 1) {
                            this.baseInfo = res.data;
                        }
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新')
                }
            },
            swiperBanner () {
                indexBanner({
                    type: 'PC',
                    page: 1,
                    limit: 10000
                }).then(res => {
                    console.log(res, '轮播图');
                    if (res.code == 1) {
                        this.bannerPic = res.data;
                    }
                })
            },
            onSwiper(swiper) {
                console.log(swiper);
            },
            onSlideChange() {
                console.log('slide change');
            },
        }
    }
</script>

<style scoped lang="scss">

    /* 过渡 */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 2.5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .index {
        /* banner */
        @media screen and (min-width: 1920px) {
            .swiper {
                /* 轮播图 */
                &::v-deep {
                    .swiper-container {
                        width: 100%;
                        height: 840px;
                    }
                    .swiper-pagination-bullet {
                        background: #BBBBBB;
                        width: 6px;
                        height: 6px;
                    }
                    .swiper-pagination {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .swiper-pagination-bullet-active {
                        background: #D7D7D7;
                        width: 12px;
                        height: 12px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 6px;
                            height:6px;
                            background-color: #fff;
                            border-radius: 50%;
                        }
                    }
                }
                /* 文字内容 */
                .banner {
                    width: 100%;
                    height: 960px;
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size:cover;
                  //background-image: linear-gradient(to right, #f2f2f2 , #f6f6f6);
                    //background-color: #f2f2f2;
                    overflow: hidden;
                    img {
                        width: auto;
                        height: 100%;
                      object-fit: cover!important;
                    }
                    .banner_center {
                        height: 840px;
                        .content {
                            height: 840px;
                            z-index: 20;
                            .mt {
                                margin-top: -166px;
                            }
                            .title {
                                font-size: 40px;
                                color:#262626;
                                font-weight: bold;
                            }
                            .intro {
                                margin-top: 12px;
                                font-size: 20px;
                                color:#262626;
                            }
                            .more {
                                margin-top: 36px;
                                width: 111px;
                                height: 38px;
                                border: 1px solid #262626;
                                opacity: 1;
                                border-radius: 2px;
                                font-size: 16px;
                                font-family: Alibaba PuHuiTi;
                                font-weight: 400;
                                line-height: 22px;
                                color: #262626;

                                &:hover {
                                    background-color: #262626;
                                    color: #fff;
                                }
                            }
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 1920px) {
            .swiper {
                .swiper-container {
                    width: 100%;
                    height: 840px;
                }
                &::v-deep {
                    .swiper-pagination-bullet {
                        background: #BBBBBB;
                        width: 6px;
                        height: 6px;
                    }
                    .swiper-pagination {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .swiper-pagination-bullet-active {
                        background: #D7D7D7;
                        width: 12px;
                        height: 12px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 6px;
                            height:6px;
                            background-color: #fff;
                            border-radius: 50%;
                        }
                    }
                }

                .banner {
                    width: 100%;
                    height: 840px;
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size:cover;
                    //background-image: linear-gradient(to right, #f2f2f2 , #f6f6f6);
                    //background-color: #f2f2f2;
                    overflow: hidden;

                    //img {
                    //    width: auto;
                    //    height: 100%;
                    //}
                    .banner_center {
                        height: 840px;
                        .content {
                            height: 840px;
                            z-index: 20;
                            .mt {
                                margin-top: -166px;
                            }
                            .title {
                                font-size: 40px;
                                color:#262626;
                                font-weight: bold;
                            }
                            .intro {
                                margin-top: 12px;
                                font-size: 20px;
                                color:#262626;
                            }
                            .more {
                                margin-top: 36px;
                                width: 111px;
                                height: 38px;
                                border: 1px solid #262626;
                                opacity: 1;
                                border-radius: 2px;
                                font-size: 16px;
                                font-family: Alibaba PuHuiTi;
                                font-weight: 400;
                                line-height: 22px;
                                color: #262626;
                                &:hover {
                                    background-color: #262626;
                                    color: #fff;
                                }
                            }
                        }

                    }
                }
            }
        }
        @media screen and (max-width: 1600px) {
            .swiper {
                .swiper-container {
                    width: 100%;
                    height: 740px;
                }
                &::v-deep {
                    .swiper-pagination-bullet {
                        background: #BBBBBB;
                        width: 6px;
                        height: 6px;
                    }
                    .swiper-pagination {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .swiper-pagination-bullet-active {
                        background: #D7D7D7;
                        width: 12px;
                        height: 12px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 6px;
                            height:6px;
                            background-color: #fff;
                            border-radius: 50%;
                        }
                    }
                }

                .banner {
                    width: 100%;
                    height: 740px;
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size:cover;
                    //background-image: linear-gradient(to right, #f2f2f2 , #f6f6f6);
                    //background-color: #f2f2f2;
                    overflow: hidden;

                    img {
                        width: auto;
                        height: 100%;
                    }
                    .banner_center {
                        height: 740px;
                        .content {
                            height: 740px;
                            z-index: 20;
                            .mt {
                                margin-top: -116px;
                            }
                            .title {
                                font-size: 40px;
                                color:#262626;
                                font-weight: bold;
                            }
                            .intro {
                                margin-top: 12px;
                                font-size: 20px;
                                color:#262626;
                            }
                            .more {
                                margin-top: 36px;
                                width: 111px;
                                height: 38px;
                                border: 1px solid #262626;
                                opacity: 1;
                                border-radius: 2px;
                                font-size: 16px;
                                font-family: Alibaba PuHuiTi;
                                font-weight: 400;
                                line-height: 22px;
                                color: #262626;

                                &:hover {
                                    background-color: #262626;
                                    color: #fff;
                                }
                            }

                        }

                    }
                }
            }
        }
        @media screen and (max-width: 1440px) {
            .swiper {
                .swiper-container {
                    width: 100%;
                    height: 740px;
                }
                &::v-deep {
                    .swiper-pagination-bullet {
                        background: #BBBBBB;
                        width: 6px;
                        height: 6px;
                    }
                    .swiper-pagination {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .swiper-pagination-bullet-active {
                        background: #D7D7D7;
                        width: 12px;
                        height: 12px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 6px;
                            height:6px;
                            background-color: #fff;
                            border-radius: 50%;
                        }
                    }
                }

                .banner {
                    width: 100%;
                    height: 740px;
                    //background-image: linear-gradient(to right, #f2f2f2 , #f6f6f6);
                    //background-color: #f2f2f2;
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size:cover;
                    overflow: hidden;

                    img {
                        width: auto;
                        height: 100%;
                    }
                    .banner_center {
                        height: 740px;
                        .content {
                            height: 740px;
                            z-index: 20;
                            .mt {
                                margin-top: -120px;
                            }
                            .title {
                                font-size: 40px;
                                color:#262626;
                                font-weight: bold;
                            }
                            .intro {
                                margin-top: 12px;
                                font-size: 20px;
                                color:#262626;
                            }
                            .more {
                                margin-top: 36px;
                                width: 111px;
                                height: 38px;
                                border: 1px solid #262626;
                                opacity: 1;
                                border-radius: 2px;
                                font-size: 16px;
                                font-family: Alibaba PuHuiTi;
                                font-weight: 400;
                                line-height: 22px;
                                color: #262626;

                                &:hover {
                                    background-color: #262626;
                                    color: #fff;
                                }
                            }

                        }

                    }
                }
            }
        }
        @media screen and (max-width: 1280px) {
            .swiper {
                .swiper-container {
                    width: 100%;
                    height: 640px;
                }
                &::v-deep {
                    .swiper-pagination-bullet {
                        background: #BBBBBB;
                        width: 6px;
                        height: 6px;
                    }
                    .swiper-pagination {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .swiper-pagination-bullet-active {
                        background: #D7D7D7;
                        width: 12px;
                        height: 12px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 6px;
                            height:6px;
                            background-color: #fff;
                            border-radius: 50%;
                        }
                    }
                }

                .banner {
                    width: 100%;
                    height: 640px;
                    //background-image: linear-gradient(to right, #f2f2f2 , #f6f6f6);
                    //background-color: #f2f2f2;
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size:cover;
                    overflow: hidden;

                    img {
                        width: auto;
                        height: 100%;
                    }
                    .banner_center {
                        height: 640px;
                        .content {
                            height: 640px;
                            z-index: 20;
                            .mt {
                                margin-top: -78px;
                            }
                            .title {
                                font-size: 40px;
                                color:#262626;
                                font-weight: bold;
                            }
                            .intro {
                                margin-top: 12px;
                                font-size: 20px;
                                color:#262626;
                            }
                            .more {
                                margin-top: 36px;
                                width: 111px;
                                height: 38px;
                                border: 1px solid #262626;
                                opacity: 1;
                                border-radius: 2px;
                                font-size: 16px;
                                font-family: Alibaba PuHuiTi;
                                font-weight: 400;
                                line-height: 22px;
                                color: #262626;

                                &:hover {
                                    background-color: #262626;
                                    color: #fff;
                                }
                            }

                        }

                    }
                }
            }
        }
        @media screen and (max-width: 1024px) {
            .swiper {
                .swiper-container {
                    width: 100%;
                    height: 540px;
                }
                &::v-deep {
                    .swiper-pagination-bullet {
                        background: #BBBBBB;
                        width: 6px;
                        height: 6px;
                    }
                    .swiper-pagination {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .swiper-pagination-bullet-active {
                        background: #D7D7D7;
                        width: 12px;
                        height: 12px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 6px;
                            height:6px;
                            background-color: #fff;
                            border-radius: 50%;
                        }
                    }
                }

                .banner {
                    width: 100%;
                    height: 540px;
                    //background-image: linear-gradient(to right, #f2f2f2 , #f6f6f6);
                    //background-color: #f2f2f2;
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size:cover;
                    overflow: hidden;

                    img {
                        width: auto;
                        height: 100%;
                    }
                    .banner_center {
                        height: 540px;
                        .content {
                            height: 540px;
                            z-index: 20;
                            .mt {
                                margin-top: -50px;
                            }
                            .title {
                                font-size: 40px;
                                color:#262626;
                                font-weight: bold;
                            }
                            .intro {
                                margin-top: 12px;
                                font-size: 20px;
                                color:#262626;
                            }
                            .more {
                                margin-top: 36px;
                                width: 111px;
                                height: 38px;
                                border: 1px solid #262626;
                                opacity: 1;
                                border-radius: 2px;
                                font-size: 16px;
                                font-family: Alibaba PuHuiTi;
                                font-weight: 400;
                                line-height: 22px;
                                color: #262626;

                                &:hover {
                                    background-color: #262626;
                                    color: #fff;
                                }
                            }

                        }

                    }
                }
            }
        }

        /* 各模块头部样式 */
        .header {
            .title {
                font-size: 30px;
                font-weight: bold;
                line-height: 38px;
                color: #262626;
            }

            .line {
                width: 20px;
                height: 2px;
                background: #333333;
                opacity: 1;
                margin-top: 20px;
            }
        }

        /* 各模块更多按钮的样式 */
        .more_area {
            margin-top: 48px;

            .more {
                width: 111px;
                height: 42px;
                border: 1px solid #262626;
                opacity: 1;
                border-radius: 2px;
                font-size: 16px;
                font-family: Alibaba PuHuiTi;
                font-weight: 400;
                line-height: 22px;
                color: #262626;

                &:hover {
                    background-color: #262626;
                    color: #fff;
                }
            }
        }

        /* 企业背景 */
        .enterprise {
            width: 100%;
            height: 260px;
            position: relative;
            overflow: hidden;
            .e_img {
                position: absolute;
                top: 0;
                left:0;
                z-index: 0;
                width:100%;
                height: 80%;
                background: #262626 url("../assets/pc_pic/index/homepage.png") no-repeat center center;
                background-size: cover;
                filter: blur(50px);
            }
            .e_bg {
                position: absolute;
                top: 0;
                left:0;
                z-index: 10;
                width: 100%;
                height: 100%;
                background-color: rgba(38, 38, 38, .8);
                .enterprise_center {
                    padding: 80px 0;

                    .title {
                        font-size: 30px;
                        font-weight: bold;
                        line-height: 38px;
                        color: #FFFFFF;
                    }

                    .intro {
                        margin-top: 12px;
                        font-size: 16px;
                        width: 478px;
                        font-weight: 400;
                        line-height: 24px;
                        color: #FFFFFF;
                        opacity: 0.8;
                        &::v-deep {
                            p {
                                margin-top: 0!important;
                                margin-bottom: 0!important;
                            }
                        }
                    }
                }
            }

        }

        /* 新闻资讯 */
        .news {
            width: 100%;

            .news_center {
                padding: 50px 0;

                .news_area {
                    margin-top: 48px;

                    .r_txt {
                        left: 0;
                        bottom: 0;
                        padding: 32px;
                        box-sizing: border-box;
                        background: linear-gradient(180deg, rgba(51, 51, 51, 0) 0%, rgba(0, 0, 0, 0.6) 100%);

                        .r_title {
                            font-size: 24px;
                            font-weight: bold;
                            line-height: 32px;
                            color: #FFFFFF;
                        }

                        .r_intro {
                            margin-top: 8px;
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 24px;
                            color: #FFFFFF;
                            opacity: 0.8;
                            display: none;
                            &::v-deep {
                                p {
                                    margin-top: 0px!important;
                                    margin-bottom: 0px!important;
                                }
                            }
                        }

                        .n_more {
                            display: none;
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 24px;
                            color: #1890FF;
                            opacity: 1;
                            margin-top: 20px;

                            .more-icon {
                                font-size: 20px;
                                line-height: 24px;
                            }
                        }
                    }

                    .left {
                        width: 630px;
                        height: 640px;
                        margin-right: 32px;
                        overflow: hidden;
                        border-radius: 4px;

                        .image {
                            width: 100%;
                            height: 100%;
                            transition: all 0.6s;
                            object-fit: cover;
                        }

                        .r_txt {
                            width: 630px;
                            height: 200px;
                        }

                        &:hover {
                            .r_txt {
                                width: 630px !important;
                                height: 640px !important;
                                background: linear-gradient(180deg, rgba(51, 51, 51, 0) 0%, rgba(0, 0, 0, 0.8) 100%) !important;

                                .r_intro {
                                    display:  -webkit-box;
                                }

                                .n_more {
                                    display: block;
                                }
                            }
                            .image {
                                transform: scale(1.05);
                                transition: all 0.6s;
                            }
                        }


                    }

                    .right {
                        .r_card {
                            width: 618px;
                            height: 304px;
                            border-radius: 4px;
                            overflow: hidden;

                            .image {
                                width: 100%;
                                height: 100%;
                                transition: all 0.6s;
                            }

                            .r_txt {
                                width: 618px;
                                height: 200px;
                            }


                            &:hover {
                                .r_txt {
                                    height: 302px !important;
                                    background: linear-gradient(180deg, rgba(51, 51, 51, 0) 0%, rgba(0, 0, 0, 0.8) 100%) !important;

                                    .r_intro {
                                        display:  -webkit-box;
                                    }

                                    .n_more {
                                        display: block;
                                    }


                                }
                                .image {
                                    transform: scale(1.05);
                                    transition: all 0.6s;
                                }
                            }
                        }

                        .mt_48 {
                            margin-top: 32px;
                        }

                    }
                }
            }
        }

        /* 底部卡片 */
        .card {
            padding-bottom: 100px;

            .card_center {
                overflow: visible !important;

                .item {
                    width: 408px;
                    height: 218px;
                    opacity: 1;
                    border-radius: 12px;
                    margin-right: 32px;
                    background-color: #fafafa;
                    /*box-shadow: 0 20px 50px rgba(0, 0, 0, 0.06);*/
                    transition-duration: .5s;
                    -moz-transition-duration: .5s;
                    -webkit-transition-duration: .5s;
                    -o-transition-duration: .5s;
                    &:hover {
                        /*box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);*/
                        background-color: #262626;
                        .title {
                            color: #fff;
                        }
                        .intro {
                            color: #fff!important;
                        }
                    }

                    &:last-child {
                        margin-right: 0px;
                    }

                    .title {
                        font-size: 24px;
                        font-weight: bold;
                        line-height: 32px;
                        color: #333333;
                        opacity: 1;
                    }

                    .intro_center {
                        margin-top: 12px;
                        width: 220px;

                        .intro {
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 24px;
                            color: #8C8C8C;
                            margin-top: 2px;
                        }
                    }
                }
            }
        }
    }



</style>
